let addToastFn = null;

export const registerToastFunction = (addToast) => {
  addToastFn = addToast;
};

export const addToast = (message, code, level, autoDismiss = true) => {
  if (addToastFn) {
    addToastFn(message, code, level, autoDismiss);
  } else {
    console.warn("addToast is not registered yet");
  }
};
